// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__fYnpU","label":"LabeledBox_label__2sKUS"};